import { render, staticRenderFns } from "./view-cost-table.vue?vue&type=template&id=c3a8344c"
import script from "./view-cost-table.ts?vue&type=script&lang=ts&external"
export * from "./view-cost-table.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a8344c')) {
      api.createRecord('c3a8344c', component.options)
    } else {
      api.reload('c3a8344c', component.options)
    }
    module.hot.accept("./view-cost-table.vue?vue&type=template&id=c3a8344c", function () {
      api.rerender('c3a8344c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/view-cost-table/view-cost-table.vue"
export default component.exports